var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.severity > 2),expression:"severity > 2"}]},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'heartbeat'],"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }